export const generativeAiAgentIdLogs = "/generative_ai/agent/:id/logs";
